import Koffing from './Koffing';

export default Koffing;



/** WEBPACK FOOTER **
 ** ./source/109-koffing/index.js
 **/